import { omit, RcClasses } from '../../../../foundation';
import { RcIconSizes } from '../../../Icon/utils';
export var RcIconButtonClasses = RcClasses([
    'root',
    'disabled',
    'invisible',
    'outline',
    'contained',
    'inverse',
    'round',
    'persistBg',
], 'RcIconButton');
export var RcIconButtonTouchRippleClasses = RcClasses(['ripplePulsate', 'child'], 'RcIconButtonTouchRipple');
export var RcIconButtonSizes = omit(RcIconSizes, ['inherit']);
export var RcIconButtonFocusVisibleInsetSize = {
    xxxlarge: 6,
    xxlarge: 5,
    xlarge: 5,
    large: 4,
    medium: 3,
    small: 2,
    xsmall: 2,
};
